<monitor-ui-alert></monitor-ui-alert>

<!--suppress AngularUndefinedBinding -->
<global-nav app-label="Monitor UI" [prezUrl]="navbarService.PREZ_URL"></global-nav>

<mat-sidenav-container (backdropClick)="sidenavService.close()" [hasBackdrop]="!isLargeScreen()" autosize>
  <mat-sidenav #sidenav class="sidenav-container" fixedInViewport="true" fixedTopGap="60" [mode]="getMode()">
    <div class="sidenav-header">
      <div class="flex justify-between items-center">
        <h1 class="page-title" data-automation="listTitle">
          {{ 'APP.TITLE' | translate }}
        </h1>
        <button
          mat-icon-button
          color="accent"
          aria-label="Menu"
          class="toggle-sidenav flex justify-center items-center"
          data-automation="toggle-sidenav"
          (click)="sidenavService.toggle()"
        >
          <mat-icon>double_arrow</mat-icon>
        </button>
      </div>
    </div>
    <div class="sidenav-component-container" data-automation="tree-container">
      <monitor-ui-tree></monitor-ui-tree>
    </div>
  </mat-sidenav>

  <mat-sidenav-content data-automation="sidenav-content" [class.sidenav-content-stretch]="!sidenav?.opened">
    <div data-automation="scrollable-container" class="full overflow-auto" style="{{ sidenavContentStyle() }}">
      <div data-automation="main-container" class="main-container">
        <monitor-ui-loader></monitor-ui-loader>
        <router-outlet></router-outlet>
      </div>
    </div>
  </mat-sidenav-content>
</mat-sidenav-container>
